import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import {Columns, Heading, Table} from "react-bulma-components";


export default function MovementFigures({movementData, movementLoaded}){
    const colour = () => {
        if(movementData.total > 0){
            return "table-highlight-green-black-text"
        }
        else if(movementData.total < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }

    if(!movementLoaded){
        return <LoadingSpinner/>
    }



    return (
        <div>
            <Heading>Movements</Heading>
            <Columns>
                <Columns.Column>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Total Movement Income</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={colour()}>{movementData.total}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    )

}